import * as Yup from 'yup';
import { REQUIRED_ERROR_MSG } from 'utils/constants/errors';

export const resetPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('Please enter a valid email')
    .required(REQUIRED_ERROR_MSG)
});
